module.exports = __webpack_public_path__ + "dash_20_app_assets/img/carousel.53327f09.png";